  <!-- Excel数据导入最后一步 - 设置表格基本信息 -->
<template>
  <div class="import-final-page">
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row class="main-content">
      <el-col :span="4" class="menu-col">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20" class="content-col">
        <!-- 页面标题 -->
        <div class="page-header">
          <h2 class="page-title">
            <i class="el-icon-document-checked"></i>
            {{import_data === '1' ? '设置表格基本信息' : '创建新表格'}}
          </h2>
          <p class="page-subtitle">
            {{import_data === '1' ? '请完善表格信息，准备导入数据' : '请完善表格信息，创建空白表格'}}
          </p>
        </div>

        <!-- 主要内容卡片 -->
        <div class="form-card">
          <!-- 步骤指示器 -->
          <div class="step-indicator" v-if="import_data === '1'">
            <div class="step-item">
              <span class="step-num active">1</span>
              <span class="step-label">选择文件</span>
            </div>
            <div class="step-arrow">
              <i class="el-icon-arrow-right"></i>
            </div>
            <div class="step-item">
              <span class="step-num active">2</span>
              <span class="step-label">预览数据</span>
            </div>
            <div class="step-arrow">
              <i class="el-icon-arrow-right"></i>
            </div>
            <div class="step-item">
              <span class="step-num active">3</span>
              <span class="step-label">设置基本信息</span>
            </div>
          </div>

          <!-- 表单内容 -->
          <div class="form-content">
            <!-- 表格名称 -->
            <div class="form-section">
              <h3 class="section-title">
                <span class="section-num">1</span>
                表格名称
                <span class="required-tag">必填</span>
              </h3>
              <div class="form-item-full">
                <el-input 
                  v-model="form_name" 
                  placeholder="请输入表格名称，如：员工信息表、客户资料表等"
                  prefix-icon="el-icon-document"
                  class="modern-input">
                </el-input>
                <div class="input-tip">请为表格起一个清晰易懂的名称</div>
              </div>
            </div>

            <!-- 领表说明 -->
            <div class="form-section">
              <h3 class="section-title">
                <span class="section-num">2</span>
                领表说明
                <span class="optional-tag">选填</span>
              </h3>
              <div class="form-item-full">
                <el-input 
                  type="textarea" 
                  :rows="3"
                  v-model="receive_notice"
                  placeholder="说明谁可以领表或在什么情况下领表"
                  class="modern-textarea">
                </el-input>
                <div class="input-tip">填写人在领表时会看到此说明</div>
              </div>
            </div>

            <!-- 填表必读 -->
            <div class="form-section">
              <h3 class="section-title">
                <span class="section-num">3</span>
                填表必读
                <span class="optional-tag">选填</span>
              </h3>
              <div class="form-item-full">
                <el-input 
                  type="textarea" 
                  :rows="3"
                  v-model="form_comment"
                  placeholder="说明填写时需要注意的事项和要求"
                  class="modern-textarea">
                </el-input>
                <div class="input-tip">填写人在填写时会看到此提示</div>
              </div>
            </div>

            <!-- 数据统计信息 -->
            <div class="form-section" v-if="import_data === '1'">
              <h3 class="section-title">
                <span class="section-num">4</span>
                导入统计
              </h3>
              <div class="stats-card">
                <div class="stat-item">
                  <div class="stat-icon">
                    <i class="el-icon-document"></i>
                  </div>
                  <div class="stat-content">
                    <div class="stat-value">{{dataList.length}}</div>
                    <div class="stat-label">数据条数</div>
                  </div>
                </div>
                <div class="stat-item">
                  <div class="stat-icon">
                    <i class="el-icon-s-grid"></i>
                  </div>
                  <div class="stat-content">
                    <div class="stat-value">{{headList.length}}</div>
                    <div class="stat-label">数据列数</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 操作按钮 -->
            <div class="form-actions">
              <el-button @click="back" class="btn-default">
                <i class="el-icon-arrow-left"></i> 上一步
              </el-button>
              <el-button type="primary" @click="nextStep" class="btn-primary-custom">
                <i class="el-icon-check"></i> {{import_data === '1' ? '下一步，设置导入规则' : '立即创建表格'}}
              </el-button>
            </div>
          </div>
        </div>

        <!-- 进度条提示 -->
        <div class="progress-hint" v-if="import_data === '1'">
          <el-progress :percentage="66" :show-text="false" :stroke-width="6" color="#2CCB92"></el-progress>
          <p class="hint-text">已完成 2/3 步骤</p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'
  import '../assets/global.css'
  import tableItem from './tableItem'
  import Utils from '../utils/utils.js'

  export default {
    components: {
      MenuList,
      Header,
      tableItem
    },
    data() {
      return {
        username: '',
        form_name: '',
        form_comment: '',
        dataList: [],
        headList: [],

        transferList: [],
        selectedCondition: '',

        input_pages: '1',
        import_data: '',

        receive_notice: ''
      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      this.dataList = JSON.parse(this.$route.params.dataList)
      this.headList = JSON.parse(this.$route.params.headList)
      this.import_data = this.$route.params.import_data

      this.transferList = []
      for (var i = 0; i < this.headList.length; i++) {
        let item = {
          key: this.headList[i].prop,
          label: this.headList[i].label,
          disabled: false
        }
        this.transferList.push(item)
      }

      console.log('this.transferList', this.transferList)
    },
    methods: {
      nextStep() {
        if (Utils.isEmpty(this.form_name)) {
          this.$message.error('请输入表格名称')
          return
        }

        let that = this

        var requestUrl = '/form/web/_import_excel_form_data.jsp'
        // 开启loading

        let data = {
          username: that.username,
          form_name: that.form_name,
          form_comment: that.form_comment,
          receive_notice: that.receive_notice,
          head_list: JSON.stringify(that.headList),
          data_list: JSON.stringify(that.dataList),
          // condition_list: that.selectedCondition,
          input_pages: that.input_pages,
          import_data: that.import_data
        }

        // console.log('head_list====', that.headList)

        var qs = require('qs')

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: '正在导入,请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        this.axios.post(
            requestUrl,
            qs.stringify(data), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          ).then(function(response) {
            // that.$message({
            //   duration: 5000,
            //   message: '导入成功！如需修改，请在微信中用多人填表修改！',
            //   type: 'success'
            // })
            load.close()

            if (that.import_data === '1') {
              // 判断是否有固定列数据
              var formId = response.data.form_id
              that.$router.push({
                name: 'set_valid_condition',
                params: {
                  form_id: formId,
                  form_name: that.form_name
                }
              })
            } else {
              that.$router.push({
                path: '/form_list',
                params: {
                  username: that.username
                }
              })
            }
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      back() {
        this.$router.back()
      },
      hasFixColumn() {
        let that = this
        var hasFixed = false

        for (var i = 0; i < that.headList.length; i++) {
          let column = that.headList[i]
          if (column.can_edit == '0') {
            hasFixed = true
            break
          }
        }

        return hasFixed
      }

    }
  }
</script>

<style scoped>
  /* 页面整体 */
  .import-final-page {
    min-height: 100vh;
    background: #f5f7fa;
  }

  .main-content {
    padding: 20px;
  }

  .content-col {
    padding-left: 20px;
  }

  /* 页面标题 */
  .page-header {
    margin-bottom: 30px;
  }

  .page-title {
    font-size: 24px;
    font-weight: 600;
    color: #333;
    margin: 0 0 8px;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .page-title i {
    color: #2CCB92;
    font-size: 28px;
  }

  .page-subtitle {
    font-size: 14px;
    color: #888;
    margin: 0;
  }

  /* 表单卡片 */
  .form-card {
    background: #fff;
    border-radius: 16px;
    padding: 30px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.06);
    margin-bottom: 30px;
  }

  /* 步骤指示器 */
  .step-indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 40px;
    padding: 20px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 12px;
  }

  .step-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  .step-num {
    width: 32px;
    height: 32px;
    background: #e8e8e8;
    color: #888;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.3s ease;
  }

  .step-num.active {
    background: linear-gradient(135deg, #2CCB92 0%, #25b582 100%);
    color: #fff;
    box-shadow: 0 4px 12px rgba(44, 203, 146, 0.3);
  }

  .step-label {
    font-size: 13px;
    color: #666;
    font-weight: 500;
  }

  .step-arrow {
    margin: 0 20px;
    color: #ccc;
    font-size: 20px;
  }

  /* 表单内容 */
  .form-content {
    padding: 10px;
  }

  /* 表单分区 */
  .form-section {
    margin-bottom: 30px;
    padding-bottom: 30px;
    border-bottom: 1px dashed #e8e8e8;
  }

  .form-section:last-of-type {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }

  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 0 0 20px;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .section-num {
    width: 28px;
    height: 28px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
  }

  .required-tag {
    background: linear-gradient(135deg, #FFCB2F 0%, #ffb700 100%);
    color: #333;
    padding: 2px 10px;
    border-radius: 10px;
    font-size: 11px;
    margin-left: 10px;
  }

  .optional-tag {
    background: linear-gradient(135deg, #e8e8e8 0%, #d9d9d9 100%);
    color: #666;
    padding: 2px 10px;
    border-radius: 10px;
    font-size: 11px;
    margin-left: 10px;
  }

  /* 表单项 */
  .form-item-full {
    width: 100%;
  }

  .modern-input ::v-deep .el-input__inner {
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    padding: 12px 15px;
    font-size: 14px;
    transition: all 0.3s ease;
  }

  .modern-input ::v-deep .el-input__inner:focus {
    border-color: #1485FB;
    box-shadow: 0 0 0 3px rgba(20, 133, 251, 0.1);
  }

  .modern-textarea ::v-deep .el-textarea__inner {
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    padding: 12px 15px;
    font-size: 14px;
    transition: all 0.3s ease;
    line-height: 1.6;
  }

  .modern-textarea ::v-deep .el-textarea__inner:focus {
    border-color: #1485FB;
    box-shadow: 0 0 0 3px rgba(20, 133, 251, 0.1);
  }

  .input-tip {
    font-size: 12px;
    color: #999;
    margin-top: 8px;
  }

  /* 统计卡片 */
  .stats-card {
    display: flex;
    gap: 20px;
  }

  .stat-item {
    flex: 1;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 12px;
    padding: 20px;
    display: flex;
    align-items: center;
    gap: 15px;
    border: 1px solid #f0f0f0;
  }

  .stat-icon {
    width: 48px;
    height: 48px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 20px;
  }

  .stat-content {
    flex: 1;
  }

  .stat-value {
    font-size: 28px;
    font-weight: 700;
    color: #333;
    line-height: 1;
    margin-bottom: 4px;
  }

  .stat-label {
    font-size: 13px;
    color: #666;
  }

  /* 表单操作按钮 */
  .form-actions {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 40px;
    padding-top: 30px;
    border-top: 1px solid #e8e8e8;
  }

  .btn-default {
    padding: 12px 30px;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    color: #666;
    transition: all 0.3s ease;
  }

  .btn-default:hover {
    border-color: #1485FB;
    color: #1485FB;
    transform: translateY(-1px);
  }

  .btn-primary-custom {
    background: linear-gradient(135deg, #2CCB92 0%, #25b582 100%);
    border: none;
    border-radius: 8px;
    padding: 12px 40px;
    font-size: 15px;
    color: #fff;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(44, 203, 146, 0.3);
  }

  .btn-primary-custom:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(44, 203, 146, 0.4);
  }

  /* 进度提示 */
  .progress-hint {
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.04);
  }

  .hint-text {
    text-align: center;
    font-size: 14px;
    color: #666;
    margin-top: 10px;
    margin-bottom: 0;
  }

  ::v-deep .el-progress-bar__outer {
    border-radius: 4px;
    background-color: #f0f0f0;
  }

  ::v-deep .el-progress-bar__inner {
    border-radius: 4px;
  }

  /* 响应式设计 */
  @media (max-width: 768px) {
    .main-content {
      padding: 10px;
    }

    .content-col {
      padding-left: 0;
      margin-top: 15px;
    }

    .form-card {
      padding: 20px;
    }

    .step-indicator {
      flex-direction: column;
      gap: 15px;
    }

    .step-arrow {
      transform: rotate(90deg);
      margin: 5px 0;
    }

    .stats-card {
      flex-direction: column;
    }

    .form-actions {
      flex-direction: column;
    }

    .page-title {
      font-size: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/excel_data_import_final_step.vue